import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded shadow-sm p-5 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 w-100 text-center" }, "Création de compte", -1)
const _hoisted_3 = {
  class: "stepper stepper-pills",
  id: "kt_stepper_sign_up",
  ref: "signUpStepper"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"stepper-nav flex-center flex-wrap mb-3\"><div class=\"stepper-item mx-lg-2 my-4 current\" data-kt-stepper-element=\"nav\"><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">1</span></div><div class=\"stepper-label d-none d-lg-flex\"><h3 class=\"stepper-title\">Informations</h3></div></div><div class=\"stepper-item mx-lg-2 my-4\" data-kt-stepper-element=\"nav\"><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">2</span></div><div class=\"stepper-label d-none d-lg-flex\"><h3 class=\"stepper-title\">Conditions générales d&#39;utilisation</h3></div></div><div class=\"stepper-item mx-lg-2 my-4\" data-kt-stepper-element=\"nav\"><div class=\"stepper-icon w-40px h-40px\"><i class=\"stepper-check fas fa-check\"></i><span class=\"stepper-number\">3</span></div><div class=\"stepper-label d-none d-lg-flex\"><h3 class=\"stepper-title\"> Charte de protection des données personnelles </h3></div></div></div>", 1)
const _hoisted_5 = {
  class: "flex-column current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "mb-3 mb-lg-6 text-center" }
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_8 = { class: "row fv-row mb-7" }
const _hoisted_9 = { class: "col-xl-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Prénom", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "col-xl-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Nom", -1)
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-row mb-7" }
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid required" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3" }, " Je suis agriculteur à titre principal ou secondaire ", -1)
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid mt-2 required" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bolder text-dark fs-6 ms-0 me-3" }, " Je ne suis pas agriculteur ", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Dans tous les cas, vous pourrez remplir des diagnostics biodiversité ", -1)
const _hoisted_25 = { class: "fv-row mb-7" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Email", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "mb-7 fv-row" }
const _hoisted_30 = { class: "mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, " Mot de passe ", -1)
const _hoisted_32 = { class: "position-relative mb-3" }
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Utilisez au moins 10 caractères avec au moins un chiffre, une minuscule, une majuscule et un caractère spécial parmi les suivants : ~ ! @ # $ % ^ & * ( ) _ + { } \" : ; ' [ ] ? , . \\ / = + € - ° § ¿ • ± ¥ Ø ", -1)
const _hoisted_36 = { class: "fv-row mb-7" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Confirmation du mot de passe", -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = {
  class: "flex-column align-items-center mb-3",
  "data-kt-stepper-element": "content"
}
const _hoisted_41 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, " En cochant cette case, j'accepte les Conditions générales d'utilisations ci-dessus. ", -1)
const _hoisted_43 = {
  class: "flex-column align-items-center mb-3",
  "data-kt-stepper-element": "content"
}
const _hoisted_44 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, " En cochant cette case, j'accepte la charte de protection des données personnelles ci-dessus. ", -1)
const _hoisted_46 = { class: "d-flex flex-stack" }
const _hoisted_47 = { class: "me-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Valider ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Veuillez patienter "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_GdprDocViewer = _resolveComponent("GdprDocViewer")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        onSubmit: _ctx.onSubmitRegister,
        id: "kt_stepper_sign_up_form",
        "validation-schema": _ctx.registration
      }, {
        default: _withCtx(({ values, meta }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(" Vous avez déjà un compte ? "),
                _createVNode(_component_router_link, {
                  to: "/connexion",
                  class: "link-primary fw-bolder"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Se connecter ici ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "first_name",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "first_name" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  placeholder: "",
                  name: "last_name",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_ErrorMessage, { name: "last_name" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "radio",
                  name: "professional_farmer",
                  value: "1"
                }),
                _hoisted_19
              ]),
              _createElementVNode("label", _hoisted_20, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "radio",
                  name: "professional_farmer",
                  value: "0"
                }),
                _hoisted_21
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_ErrorMessage, { name: "professional_farmer" })
                ])
              ]),
              _hoisted_24
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "email",
                placeholder: "",
                name: "email",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_ErrorMessage, { name: "email" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: _ctx.toggleVisibility ? 'password' : 'text',
                    placeholder: "",
                    name: "password",
                    autocomplete: "off"
                  }, null, 8, ["type"]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleVisibility = !_ctx.toggleVisibility)),
                    class: "mt-3 text-end link-primary fs-6 fw-bold"
                  }, _toDisplayString(_ctx.toggleVisibility
                      ? "Voir le mot de passe"
                      : "Cacher le mot de passe"), 1)
                ])
              ]),
              _hoisted_35
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: _ctx.toggleVisibility ? 'password' : 'text',
                placeholder: "",
                name: "password_confirm",
                autocomplete: "off"
              }, null, 8, ["type"]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_ErrorMessage, { name: "password_confirm" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_GdprDocViewer, { "doc-type": "general-conditions" }),
            _createElementVNode("label", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cguAccepted) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.cguAccepted]
              ]),
              _hoisted_42
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_GdprDocViewer, { "doc-type": "gdpr-charter" }),
            _createElementVNode("label", _hoisted_44, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.charterAccepted) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.charterAccepted]
              ]),
              _hoisted_45
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-active-light-primary",
                "data-kt-stepper-action": "previous",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
              }, " Précédent ")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                disabled: !(_ctx.stepValid && _ctx.registration.isValidSync(values)),
                "data-kt-stepper-action": "next",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
              }, " Suivant ", 8, _hoisted_48),
              _createElementVNode("button", {
                class: "btn btn-primary",
                "data-kt-stepper-action": "submit",
                id: "kt_sign_up_submit",
                disabled: !_ctx.stepValid || !(meta.valid && meta.dirty),
                ref: "submitButton",
                type: "submit"
              }, _hoisted_52, 8, _hoisted_49)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ], 512)
  ]))
}